// extracted by mini-css-extract-plugin
export var image = "Image-module--image--oIYK9";
export var show = "Image-module--show--3N2g5";
export var showFadeInDown = "Image-module--show-fade-in-down--2h4Z2";
export var showFadeInUp = "Image-module--show-fade-in-up--byVFa";
export var hideFadeOut = "Image-module--hide-fade-out--V1LB1";